import React from 'react';
import styles from './form.module.scss';


import Button from '../Button';


class Form extends React.Component {
  render () {
    return (
      <form id="get-started" className={styles.form} action="#">
        {this.props.children}
        <div className={'row'}>
          <label className={'col-half'}>Name <input type="text" placeholder="John or Jane Doe" /></label>
          <label className={'col-half'}>Phone <input type="text" placeholder="(###) ###-####" /></label>
        </div>
        <label>Message <textarea name="message" cols="30" rows="5" placeholder="What are your fitness goals?"></textarea></label>
        <div className={styles.buttonWrapper}>
          <Button type={'submit'}>Submit to Get CustomFIT!</Button>
        </div>
      </form>
    )
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/Form/index.js